import { faFacebookF, faYoutube, faFacebook, faWhatsapp, faTelegram } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const currentYear = new Date().getFullYear();

function Footer({ style }) {
    return (
        <footer className={`footer ${style ? 'dark-mode' : ""}`}>
            
            <Container>
                <Row className="justify-content-between">
                    <Col lg={4} md={6} className="mb-4">
                        <div className="footer-section">
                            <div className="footer-logo">
                                {/* <img src="/images/logo-light.webp" loading="lazy" alt="مستر ابو غالية "/> */}
                            </div>
                            <p className="footer-description">
                                منصة تعليمية متخصصة في اللغة الإنجليزية   تحت إشراف  مستر أحمد إبراهيم  
                            </p>
                        </div>
                    </Col>
                    
                    <Col lg={8} md={6} className="mb-4">
                        <div className="footer-section">
                            <h5>تواصل معنا</h5>
                            <div className="social-links">
                                <Link to="https://youtube.com/@ahmedibrahim.abughalia?si=lenFD-V7wPtnhVQb" target="_blank" className="social-link">
                                    <FontAwesomeIcon icon={faYoutube} />
                                </Link>
                                <Link to="https://www.facebook.com/share/1Abkzxuhhh/?mibextid=wwXIfr" target="_blank" className="social-link">
                                    <FontAwesomeIcon icon={faFacebookF} />
                                </Link>
                                <Link to="https://www.facebook.com/share/g/17zihGR9dg/?mibextid=wwXIfr" target="_blank" className="social-link">
                                    <FontAwesomeIcon icon={faFacebook} />
                                </Link>
                                <Link to="https://whatsapp.com/channel/0029Vb6OCgBH5JM2boCtAS3c" target="_blank" className="social-link">
                                    <FontAwesomeIcon icon={faWhatsapp} />
                                </Link>
                                <Link to="https://t.me/abughalia0" target="_blank" className="social-link">
                                    <FontAwesomeIcon icon={faTelegram} />
                                </Link>
                            </div>
                        </div>
                    </Col>
                </Row>
                
                <div className="footer-bottom">
                <div className="powered-by">
                        <span>Powered by </span>
                        <Link to="https://www.facebook.com/profile.php?id=61556333871338" target="_blank" rel="noopener noreferrer">ReachX</Link>
                    </div>
                    <div className="copyright">
                        <span>Developed by</span> 
                        <Link to="https://www.facebook.com/said.sayed.3386" target="_blank">Said</Link> , 
                        <Link to="https://www.facebook.com/ahmed.abdelhamidnassef" target="_blank">Nassef</Link> 
                        <span>All Copy Rights Reserved © {currentYear}</span>
                    </div>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;